import { styled } from '@f8n-frontend/stitches';

const Image = styled('img', {});

export default Image;
